import { GifReader } from 'omggif'
import { MediaFrame } from '../../../types'

export async function getGifFrames(source: File | string, maxFrames?: number): Promise<MediaFrame[]> {
    const url = typeof source === 'string' ? source : URL.createObjectURL(source)
    const arrayBuffer = await fetch(url).then((res) => res.arrayBuffer())
    const buffer = new Uint8Array(arrayBuffer)
    const reader = new GifReader(buffer)
    const numFrames = reader.numFrames()
    const frameCanvas = document.createElement('canvas')
    const frameContext = frameCanvas.getContext('2d')
    const frames: MediaFrame[] = []
    const step = maxFrames ? Math.floor(numFrames / maxFrames) : 1
    let lastDisposalIndex = 0

    frameCanvas.width = reader.width
    frameCanvas.height = reader.height

    for (let i = 0; i < numFrames; i += step) {
        const frame = reader.frameInfo(i)
        const lastFrame = i > 0 ? reader.frameInfo(i - 1) : null
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')

        canvas.width = reader.width
        canvas.height = reader.height

        if (context) {
            const imageData = context.getImageData(0, 0, canvas.width, canvas.height)
            reader.decodeAndBlitFrameRGBA(i, imageData.data)

            if (lastFrame) {
                if (lastFrame.disposal === 3) {
                    frameContext?.drawImage(frames[lastDisposalIndex].canvas, 0, 0)
                } else {
                    lastDisposalIndex = i
                }

                if (lastFrame.disposal === 2) {
                    frameContext?.clearRect(lastFrame.x, lastFrame.y, lastFrame.width, lastFrame.height)
                }
            }

            context.putImageData(imageData, 0, 0, frame.x, frame.y, frame.width, frame.height)
            frameContext?.drawImage(canvas, 0, 0)
            context.clearRect(0, 0, canvas.width, canvas.height)
            context.drawImage(frameCanvas, 0, 0)
        }

        frames.push({
            canvas,
            delay: frame.delay / 100,
        })
    }

    if (typeof source !== 'string') {
        URL.revokeObjectURL(url)
    }

    return frames
}
